import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrAutoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_auto"}/>
}
